export default __webpack_public_path__ + "static/media/background-popup-gift.f273d53d.png";